import http from './http/index';
import forResponse from '../utils/forResponse';
import { TULUM_REALITY_SHOW_CHAT_ACCESS, TULUM_REALITY_SHOW_STREAMS } from '../constants/apiUrls/apiUrls';

export const getChatAccess = () => forResponse(http.post(TULUM_REALITY_SHOW_CHAT_ACCESS));

export const getTulumStreams = () => forResponse(http.get(TULUM_REALITY_SHOW_STREAMS));
